import type { Profile, SupportedOnboardingTourStep, UpdateOnboardingTourStepOptionHandler } from 'models';
import { useCallback, useState } from 'react';
import { Col, Row } from 'ui';
import { useNavigateThroughOnboardingTourSteps } from '../hooks';
import { ConsentsStep } from './consents-step';
import { ProfileStep } from './profile-step';
import { StepHeader } from './step-header';

type P = {
  onChangeStep: UpdateOnboardingTourStepOptionHandler;
  step: SupportedOnboardingTourStep;
  steps: SupportedOnboardingTourStep[];
  viewer: Profile;
};

const SupportedStep = ({ onChangeStep, step, steps, viewer }: P) => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const { onNavigateToNextStep } = useNavigateThroughOnboardingTourSteps({ onChangeStep, step: step.step, steps });

  const onStepSuccess = useCallback(() => {
    setIsHeaderVisible(true);
    onNavigateToNextStep?.();
  }, [onNavigateToNextStep]);

  const onConsent = useCallback((id?: string) => {
    setIsHeaderVisible(!id);
  }, []);

  return (
    <Row gutter={[0, 'xl']}>
      {isHeaderVisible ? (
        <Col span={24}>
          <StepHeader onChangeStep={onChangeStep} step={step} steps={steps} />
        </Col>
      ) : null}

      <Col span={24}>
        {step.step === 'profile' ? <ProfileStep onSuccess={onStepSuccess} step={step} viewer={viewer} /> : null}
        {step.step === 'consents' ? (
          <ConsentsStep onConsent={onConsent} onSuccess={onStepSuccess} step={step} viewer={viewer} />
        ) : null}
      </Col>
    </Row>
  );
};

export default SupportedStep;
